






































































































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import WashingListForm from './WashingListForm/WashingListForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'previewDealProducts',

      'documents', 'lastMeta', 'stats', 'meta'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WashingList extends Vue {
  radioButton = 1;
  previewRow = null;

  master: any = null;
  operator: any = null;
  line: any = null;
  targetDates: any[] = [];

  open = false;
  prevent = false;

  get titleStack () {
    return [
      'Мойки'
    ]
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  get clientTypes() {
    return [
      {
        id: 'client',
        label: 'Клиент'
      },
      {
        id: 'partner',
        label: 'Партнер'
      },
      {
        id: 'supplier',
        label: 'Поставщик'
      }
    ]
  }

  filterForm: any = {}
  dealsIds: any = []

  get filtersCount() {
    return Object.keys(this.filterForm).reduce((cur: number, filterKey: any) => {
      return cur + ((this.filterForm[filterKey] && this.filterForm[filterKey].length > 0) ? 1 : 0);
    }, 0);
  }

  @Watch('$route.query')
  public checkFilterChange() {
    this.master = this.getQueryParam('master');
    this.operator = this.getQueryParam('operator');
    this.line = this.getQueryParam('line');

    if (this.getQueryParam('since')) {
      this.targetDates = [
        // @ts-ignore
        moment(this.$route.query.since).toDate(),
        // @ts-ignore
        moment(this.$route.query.until).toDate()
      ]
    }
  }

  clearDate() {
    this.targetDates = []
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: null,
        until: null,
      }
    })
  }


  onFilterChange(filter: string, value: any) {
    console.log('onFilterChange', filter, value)
    const query = { ...this.$route.query}
    query[filter] = value
    this.$router.replace({
      query
    })
  }

  onDatesChange(dates: any) {
    console.log('onDatesChange', dates)
    this.$router.replace({
      query: {
        ...this.$route.query,
        since: moment(dates[0]).format('YYYY-MM-DD'),
        until: moment(dates[1]).format('YYYY-MM-DD'),
      }
    })
  }


  openDocument(row: any) {
    this.$buefy.modal.open({
      component: WashingListForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {}
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'created_at', this.$route.query.sortDirection || 'desc']
  }

  get selectedView() {
    return this.$route.query.view || 'data'
  }

  get selectedDealsView() {
    return this.$route.query.deals_view || 'deals'
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null


  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }
  exportAsXLSX() {
    this.$buefy.snackbar.open(`Начало экспорта данных. Данная процедура может занять некоторое время.`);

    this.$store.dispatch(`${STORE_KEY}/exportDataAsXLSX`, {
      ...this.$route.query
    }).then(() => {
      this.$buefy.snackbar.open(`Экспорт окончен. Файл должен был скачаться на ваш ПК.`);
    }).catch(() => {
      this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
    });
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.checkFilterChange();
    this.handleParamsChange();
  }

  // beforeDestroy() {
  //   this.$store.unregisterModule(STORE_KEY);
  // }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.previewRow = null;
    this.prevent = false;
    if (this.$route.query.view == 'stats') {
      this.$store.dispatch(`${STORE_KEY}/loadStatistic`, {
        ...this.$route.query
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...{
          sortField: this.$route.query.sortField || 'created_at',
          sortDirection: this.$route.query.sortDirection || 'desc'
        },
        ...this.$route.query
      });
    }
  }

}
